<template>
  <!-- 第一层嵌套 -->
  <div>
    <template v-if="obj.type===1">
      <div>
        <span>[x]</span>
        <span>[x]</span>
        <span :dataid='obj.module_uuid'>{{obj.module_name}}</span>
      </div>
    </template>

    <template v-if="obj.function_button">
      <div style="margin-left:50px">
        <span>[x]</span>
        <span>[x]</span>
        <span :dataid='obj.function_uuid'> 功能模块:{{obj.function_name}}</span>
      </div>
    </template>

    <template v-if="obj.type===3">
      <div style="margin-left:150px">
        <span>[x]</span>
        <span>[x]</span>
        <span :dataid='obj.button_uuid'>按钮名称：{{obj.button_name}}</span>
      </div>
    </template>

    <template v-if="obj.children">
      <two v-for="item in obj.children"
           :key='item.module_uuid'
           :obj='item'></two>
    </template>

    <template v-if="obj.module_function">

      <two v-for="item in obj.module_function"
           :key='item.function_uuid'
           :obj='item'></two>
    </template>

    <template v-if="obj.function_button">
      <two v-for="item in obj.function_button"
           :key='item.button_uuid'
           :obj='item'></two>
    </template>

  </div>

</template>

<script>
export default {
  name: 'two',
  components: {},
  props: {
    obj: {
      type: Object
    },
  },
  data () {
    return {

    };
  },
  created () { },
  mounted () { },
  methods: {

  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
</style>
